<template>
  <div class="stickerCodePageIdD">
    <div v-if="ifPage" class="content">
      <div class="sticker-code" v-for="(item, index) in showData" :key="index">
        <div class="inside">
          <div class="inside-top">
            <div class="inside-top-left">
              <div class="icon">
                <img
                  class="wh100"
                  src="https://image.giantgocloud.com/www/ImageMapping/image/20250408/74917079C58E40ABA4F0029133BB9C10.png"
                  alt=""
                />
              </div>
              <div class="title">{{ item.productName }}</div>
            </div>
            <div class="inside-top-right">
              <div class="text" style="position: relative">
                <div
                  style="
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 1px;
                    background-color: #595757;
                    transform-origin: 0 0;
                    transform: scaleY(0.5);
                  "
                ></div>
                <div
                  style="
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 1px;
                    height: 100%;
                    background-color: #595757;
                    transform-origin: 100% 0;
                    transform: scaleX(0.5);
                  "
                ></div>
                <div
                  style="
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    height: 1px;
                    background-color: #595757;
                    transform-origin: 0 100%;
                    transform: scaleY(0.5);
                  "
                ></div>
                <div
                  style="
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 1px;
                    height: 100%;
                    background-color: #595757;
                    transform-origin: 0 0;
                    transform: scaleX(0.5);
                  "
                ></div>
                编号
              </div>
              <div class="number" style="position: relative">
                <div
                  style="
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 1px;
                    background-color: #595757;
                    transform-origin: 0 0;
                    transform: scaleY(0.5);
                  "
                ></div>
                <div
                  style="
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 1px;
                    height: 100%;
                    background-color: #595757;
                     transform-origin: 100% 0;
                    transform: scaleX(0.5);
                  "
                ></div>
                <div
                  style="
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    height: 1px;
                    background-color: #595757;
                   transform-origin: 0 100%;
                    transform: scaleY(0.5);
                  "
                ></div>
                <!-- <div style="position: absolute;left: 0;top: 0;width: 0.1px;height: 100%;background-color: #595757;transform: scaleX(0.5);"></div> -->
                {{ item.productCode }}
              </div>
            </div>
          </div>
         <div class="inside-line" style="margin-top: 6px;">
              <div
              style="
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 2px;
                background-color: #595757;
                transform-origin: 0 100%;
                transform: scaleY(0.5);
              "
            ></div>
          </div>

          <div class="" style='display: flex;'>
            <div style="width: 8px;height: 8px;background-color: #595757;border-radius: 50%;flex-shrink: 0;margin-top: 8px;"></div>
            <div class="ingredient">配料：{{ item.labelIngredient }}</div>
          </div>
          <div class="nutrients">营养成分表</div>
          <div class="nutrients-box">
           <div class="nutrients-box-title">
              <div
                style="
                  position: absolute;
                  left: 0;
                  top: 0;
                  width: 100%;
                  height: 1px;
                  background-color: #595757;
                  transform-origin: 0 0;
                  transform: scaleY(0.5);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  right: 0;
                  top: 0;
                  width: 1px;
                  height: 100%;
                  background-color: #595757;
                   transform-origin: 100% 0;
                  transform: scaleX(0.5);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  left: 0;
                  bottom: 0;
                  width: 100%;
                  height: 1px;
                  background-color: #595757;
                  transform-origin: 0 100%;
                  transform: scaleY(0.5);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  left: 0;
                  top: 0;
                  width: 1px;
                  height: 100%;
                  background-color: #595757;
                   transform-origin: 0 0;
                  transform: scaleX(0.5);
                "
              ></div>
              <div class="">项目</div>
              <div class="title-list">每100克(g)</div>
              <div class="title-list">NRV%</div>
            </div>
            <div class="nutrients-boxContent-list" style="position: relative">
              <!-- <div style="position: absolute;left: 0;top: 0;width: 100%;height: 0.1px;background-color: #595757;transform: scaleY(0.5);"></div> -->
              <div
                style="
                  position: absolute;
                  right: 0;
                  top: 0;
                  width: 1px;
                  height: 100%;
                  background-color: #595757;
                   transform-origin: 100% 0;
                  transform: scaleX(0.5);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  left: 0;
                  bottom: 0;
                  width: 100%;
                  height: 1px;
                  background-color: #595757;
                  transform-origin: 0 100%;
                  transform: scaleY(0.5);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  left: 0;
                  top: 0;
                  width: 1px;
                  height: 100%;
                  background-color: #595757;
                  transform-origin: 0 0;
                  transform: scaleX(0.5);
                "
              ></div>
              <div
                class="nutrients-box-list"
                v-for="(item1, index1) in item.nutrients"
                :key="index1"
              >
                <div style="width: 94px; padding-left: 26px">
                  {{ item1.nutrientsName }}
                </div>
                <div style="width: 94px">
                  {{ item1.nutrientsProportion }}
                </div>
                <div class="nutrients-box-list-item">
                  {{ item1.nutrientsPercent }}%
                </div>
              </div>
            </div>
          </div>
          <div class="attention-box">
            <div
              class="attention-box-item"
              v-for="(item1, index1) in item.other"
              :key="index1"
            >
              <div class="" style='display: flex;'>
                <div style="width: 8px;height: 8px;background-color: #595757;border-radius: 50%;flex-shrink: 0;margin-top: 2px;"></div>
                <div class="left" style="width: 100%">
                     {{ item1.label }}：{{ item1.text }}
                </div>
              </div>
              <!-- <div class="right">{{ item1.text }}</div> -->
            </div>
          </div>
          <div class="net-content">净含量: {{ item.netcontent }}g</div>
          <div class="qr-code">
            <div class="qr-code-left">
              <img class="wh100" :src="item.productQrCodePicture" />
            </div>
            <div v-if="item?.tempA" style="margin-left: 16px">
              <div class="code_bar" v-html="item.temp"></div>
              <div class="num_position" v-html="item.tempA"></div>
              <!--    <canvas
                class="qr-code-right"
                :ref="'barcodeCanvas' + index"
              ></canvas> -->
            </div>
          </div>
          <div class="tips">
            本产品不能替代特殊医学用途配方食品、婴幼儿食品、保健食品等特殊食品。
          </div>
          <div class="inside-line" style="margin-top: 8px;">
  <div
              style="
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 2px;
                background-color: #595757;
                transform-origin: 0 100%;
                transform: scaleY(0.5);
              "
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import JsBarcode from 'jsbarcode'
import { GenerateStampSingle } from '@/api/index'
const numberPresent = {
  0: {
    A: '0001101',
    B: '0100111',
    C: '1110010'
  },
  1: {
    A: '0011001',
    B: '0110011',
    C: '1100110'
  },
  2: {
    A: '0010011',
    B: '0011011',
    C: '1101100'
  },
  3: {
    A: '0111101',
    B: '0100001',
    C: '1000010'
  },
  4: {
    A: '0100011',
    B: '0011101',
    C: '1011100'
  },
  5: {
    A: '0110001',
    B: '0111001',
    C: '1001110'
  },
  6: {
    A: '0101111',
    B: '0000101',
    C: '1010000'
  },
  7: {
    A: '0111011',
    B: '0010001',
    C: '1000100'
  },
  8: {
    A: '0110111',
    B: '0001001',
    C: '1001000'
  },
  9: {
    A: '0001011',
    B: '0010111',
    C: '1110100'
  }
}

const version = [
  ['A', 'A', 'A', 'A', 'A', 'A'],
  ['A', 'A', 'B', 'A', 'B', 'B'],
  ['A', 'A', 'B', 'B', 'A', 'B'],
  ['A', 'A', 'B', 'B', 'B', 'A'],
  ['A', 'B', 'A', 'A', 'B', 'B'],
  ['A', 'B', 'B', 'A', 'A', 'B'],
  ['A', 'B', 'B', 'B', 'A', 'A'],
  ['A', 'B', 'A', 'B', 'A', 'B'],
  ['A', 'B', 'A', 'B', 'B', 'A'],
  ['A', 'B', 'B', 'A', 'B', 'A']
]

export default {
  data () {
    return {
      ifPage: false,
      showData: [],
      tempA: '',
      temp: ''
    }
  },
  created () {
    setTimeout(() => {
      this.ifPage = true
    }, 1000)
    const OrderId = this.$query('OrderId')
    const ProductId = this.$query('ProductId')
    const WebsiteOwner = this.$query('WebsiteOwner')
    this.getCoedData({ OrderId, ProductId, WebsiteOwner })
  },
  methods: {
    // 获取数据
    getCoedData (OrderId) {
      GenerateStampSingle(OrderId).then((res) => {
        this.showData = [res.data]
        // 数据加载完成后生成条形码
        this.$nextTick(() => {
          setTimeout(() => {
            this.generateAllBarcodes()
          }, 100)
        })
      })
    },

    // 为所有数据生成条形码
    generateAllBarcodes () {
      // this.showData.forEach((item, index) => {
      for (let i = 0; i < this.showData.length; i++) {
        this.generateBarcode(i, this.showData[i].productBarCode)
      }
      // })
    },
    produceCodeBar (valueA, index) {
      let content = valueA
      console.log('content', content.length)
      console.log('valueA', valueA)
      if (content.length !== 12) {
      } else {
        const num = new Array()
        let even = 0
        let odd = 0
        for (let i = 0; i < 12; i++) {
          num[11 - i] = parseInt(content % 10)
          content /= 10
          // 记录奇数位偶数位数字之和
          if (i % 2 == 1) {
            odd += num[11 - i] // 奇数位
          } else {
            even += num[11 - i]
          } // 偶数位
        }
        const check = even * 3 + odd
        num[12] = 10 - (check % 10)
        if (num[12] == 10) {
          num[12] = 0
        }
        console.log('1', num[12])
        let temp =
          "<div><div class='bar_long color_1'></div><div class='bar_long color_0'></div><div class='bar_long color_1'></div>"
        console.log('2')
        for (let i = 1; i <= 6; i++) {
          const ver = num[0]
          console.log('3')
          const choosen = version[ver][i - 1]
          let numTemp = parseInt(numberPresent[num[i]][choosen])
          for (let j = 0; j < 7; j++) {
            console.log('4')
            if (parseInt(numTemp / Math.pow(10, 6 - j)) === 0) {
              console.log('5')
              temp += "<div class='bar color_0'></div>"
            } else {
              console.log('6')
              temp += "<div class='bar color_1'></div>"
            }
            console.log('7')
            numTemp %= Math.pow(10, 6 - j)
          }
        }
        console.log('8')
        temp +=
          "<div class='bar_long color_0'></div><div class='bar_long color_1'></div>" +
          "<div class='bar_long color_0'></div><div class='bar_long color_1'></div>" +
          "<div class='bar_long color_0'></div>"
        // console.log('9')
        for (let i = 7; i < 13; i++) {
          // console.log('10', numberPresent)
          // console.log('10_1', num)
          // console.log('10_2', i)
          // console.log('10_3', num[i])
          // let numTemp = parseInt(numberPresent[num[i]].C)
          let numTemp = numberPresent[num[i]]?.C
            ? numberPresent[num[i]].C
            : numberPresent[0].C
          // console.log('11')
          for (let j = 0; j < 7; j++) {
            // console.log('12')
            if (parseInt(numTemp / Math.pow(10, 6 - j)) === 0) {
              // console.log('13')
              temp += "<div class='bar color_0'></div>"
            } else {
              // console.log('14')
              temp += "<div class='bar color_1'></div>"
            }
            // console.log('15')
            numTemp %= Math.pow(10, 6 - j)
          }
        }
        // console.log('16')
        temp +=
          "<div class='bar_long color_1'></div><div class='bar_long color_0'></div>" +
          "<div class='bar_long color_1'></div><div class='clearfix'></div> "
        // document.getElementById('code_bar').innerHTML(temp)
        this.showData[index].temp = temp
        let tempA = "<div class='numNum start'>" + num[0] + '</div>'
        tempA += ''
        for (let i = 1; i < 7; i++) {
          tempA += "<div class='numNum dataPart'>" + num[i] + '</div>'
        }
        tempA += "<div class='numNum center'>xx</div>"
        for (let i = 7; i < 13; i++) {
          tempA += "<div class='numNum dataPart'>" + num[i] + '</div>'
        }
        tempA += "<div class='clearfix'></div>"
        // console.log('index', index)
        this.showData[index].tempA = tempA
        // console.log('this.showData', this.showData)
        // document.getElementById('num_position').innerHTML(tempA)
      }
    },
    // 生成单个条形码
    generateBarcode (index, code) {
      console.log('code', code)
      if (code) {
        let aa = ''
        for (let i = 0; i < code.length; i++) {
          if (i != code.length - 1) {
            aa = aa + code[i]
          }
        }
        console.log('aa', aa)
        this.produceCodeBar(aa, index)
      } else {
        this.showData[index].temp = false
        this.showData[index].tempA = false
      }

      // const validCode = this.validateEAN13(code);
      // const canvasRef = this.$refs[`barcodeCanvas${index}`]?.[0]; // 获取DOM元素

      // if (!canvasRef) return;

      // JsBarcode(canvasRef, validCode, {
      //   format: "EAN13",
      //   displayValue: true,
      //   fontSize: 18,
      //   width: 1.8,
      //   height: 70,
      //   margin: 6,
      //   lineColor: "#000",
      //   textAlign:"right",
      //   textPosition:"bottom",
      //   font:"Courier",
      //   textMargin:'2px',
      // });
    },

    // EAN-13校验码计算
    validateEAN13 (code) {
      if (!code) return '6900000000000' // 默认值

      // 移除非数字字符
      const cleanCode = code.toString().replace(/\D/g, '')

      // 已经是13位直接返回
      if (cleanCode.length === 13) return cleanCode

      // 12位补校验码
      if (cleanCode.length === 12) {
        const sum = cleanCode
          .split('')
          .reduce(
            (acc, digit, i) => acc + parseInt(digit) * (i % 2 === 0 ? 1 : 3),
            0
          )
        const checksum = (10 - (sum % 10)) % 10
        return cleanCode + checksum
      }

      console.warn(`Invalid barcode: ${code}, using default`)
      return '6900000000000' // 兜底值
    }
  }
}
</script>
<style lang="scss">
.stickerCodePageIdD {
  // div {
  //   font-family: MicrosoftYaHei;
  // }
  .wh {
    width: 100%;
    height: 100%;
  }
  .sticker-code {
    width: 316px;
    height: 600px;
    padding-left: 15px;
    padding-top: 15px;
    .inside {
      transform: scale(1.1);
      transform-origin: center center;
      width: 284px;
      height: 566px;
      border-radius: 30px;
      // box-shadow: 0 0 0 0.4px #000;
      padding: 0 24px;
      color: #595757;
      .inside-top {
        display: flex;
        justify-content: space-between;
        padding-top: 32px;
        .inside-top-left {
          display: flex;
          align-items: center;
          .icon {
            width: 16px;
            height: 16px;
          }
          .title {
            font-family:BAHNS65 !important;
            font-size: 18px;
            font-weight: 550;
            text-align: center;
          }
        }
        .inside-top-right {
          display: flex;
          align-items: center;
          width: 32px;
          height: 26px;
          border-radius: 3px;
          position: relative;
          .text {
            width: 26px;
            font-size: 8px;
            height: 24px;
            border-right: none;
            // box-shadow: -0.4px 0 0 0 #000, 0 -0.4px 0 0 #000, 0 0.4px 0 0 #000; /* 下边框 */
            padding-left: 2px;
          }
          .number {
            width: 100%;
            text-align: center;
            height: 24px;
            // box-shadow: 0 0 0 0.4px #000;
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;
          }
        }
      }
      .inside-line {
        position: relative;
        // width: 100%;
        // height: 2px;
        // background-color: #595757;
        // margin-top: 8px;
      }
      .ingredient {
        font-size: 8.24px;
        margin-top: 6px;
        font-family:BAHNS55 !important;
      }
      .nutrients {
        text-align: center;
        font-size: 14px;
        padding-top: 4px;
        font-family:BAHNS65 !important;
      }
      .nutrients-box {
        position: relative;
        width: 100%;
        height: 82px;
        margin-top: 2px;
        border-radius: 3px;
        .nutrients-box-title {
          position: relative;
          display: flex;
          justify-content: space-around;
          font-size: 8px;
          font-family:BAHNS65 !important;
        }
        .nutrients-boxContent-list {
          font-family:BAHNS55 !important;
          .nutrients-box-list {
            display: flex;
            font-size: 8px;
          }
        }
      }

      .attention-box {
        font-family:BAHNS55 !important;
        font-size: 8px;
        padding-top: 4px;
        .attention-box-item {
          display: flex;
        }
      }
      .net-content {
        font-family:BAHNS55 !important;
        font-size: 20px;
        font-weight: 520;
        padding-top: 4px;
      }
      .qr-code {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 2px;
        padding-right: 10px;
        width: 100%;
        height: 92px;
        // box-shadow: 0 0 0 0.2px #595757;
        box-shadow: 0 0 0 0.4px #595757;
        margin-top: 4px;
        border-radius: 1px;
        .qr-code-left {
          flex-shrink: 0;
          height: 74.82px;
          width: 74.82px;
        }
        .qr-code-right {
          width: 151.7px;
          height: 74px;
          margin-top: 5.6px;
        }
      }
      .tips {
        font-size: 12px;
        font-weight: 600;
        padding-top: 2px;
      }
    }
  }
  // .qr-code-right {
  //   height: 80px;
  //   width: 300px;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   overflow: hidden; /* 防止条形码溢出 */

  //   .code {
  //     max-width: 100%;
  //     max-height: 100%;
  //     object-fit: contain;
  //   }
  // }

  .produce_EAN {
    border: none;
    background: #ff8f54;
    border-radius: 8px;
    width: 320px;
    text-align: center;
    padding: 4px 10px;
    cursor: pointer;
    color: #ffffff;
  }
  .code_bar {
    margin: 0px;
    margin-bottom: 0;
    margin-top: 12px;
    width: max-content;
    transform: scaleX(0.5);
    transform-origin: 0px 0;
  }
  .width_1 {
    width: 2.8px;
  }
  .bar {
    width: 2.8px;
    height: 62px;
    float: left;
    margin: 0;
    padding: 0;
  }
  .bar_long {
    width: 2.8px;
    height: 70px;
    float: left;
  }
  .color_1 {
    background: #000000;
  }
  .color_0 {
    background: #ffffff;
  }
  .clearfix {
    clear: both;
  }
  .num_position {
    position: relative;
    top: -8px;
    left: 6px;
  }

  .numNum {
    float: left;
    /*margin:19px;*/
    font-size: 12px;
    margin-right: 2.8px;
  }
  .start {
    width: 6px;
    margin-left: -16px;
  }
  .dataPart {
    margin-top: 0;
    /*margin-left: 20px;*/
    /*text-align: center;*/
    font-size: 12px;
  }
  .dataPart:first-child {
    margin-left: 22px;
  }
  .center {
    background-color: rgba(0,0, 0, 0);
    color: rgba(0,0, 0, 0);
    height: 2px;
  }
}
</style>
